<template>
  <div class="content">
    <div class="header_search">
      <div class="topBtn">
        <Button class="item" type="primary" @click="addMember">新增客户</Button>
        <Button
          class="item"
          icon="ios-download-outline"
          type="primary"
          @click="excelCustomer"
          >导出客户Excel</Button
        >
        <Button
          class="item"
          icon="ios-download-outline"
          type="primary"
          @click="exportReturnRecord"
          >导出回访记录</Button
        >
      </div>
      <div style="padding-top: 10px; padding-right: 5px">
        <!-- 查询和其他操作 -->
        <Form ref="formValidate" :model="listQuery" :label-width="80">
          <Row>
            <Col span="4">
              <FormItem label="客户搜索" class="mb-10" style="95%">
                <Input
                  v-model="listQuery.keywords"
                  placeholder="请输入客户姓名/手机号"
                />
              </FormItem>
            </Col>
            <Col span="4">
              <FormItem label="录入人" class="mb-10" style="95%">
                <Input
                  v-model="listQuery.enter_agent"
                  placeholder="请输入录入人姓名"
                />
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="录入时间" class="mb-10">
                <DatePicker
                  type="date"
                  placeholder="请选择录入开始时间"
                  style="width: 45%"
                  :options="startEntryTime"
                  :value="defaultStartEntryTime"
                  @on-change="startTimeChange($event, 1)"
                ></DatePicker>
                <span> 至 </span>
                <DatePicker
                  type="date"
                  placeholder="请选择录入结束时间"
                  style="width: 45%"
                  :options="endEntryTime"
                  :value="defaultEndEntryTime"
                  @on-change="endTimeChange($event, 1)"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="4" v-if="showOtherSearch">
              <FormItem label="客户分组" class="mb-10">
                <dropCheckBox
                  type="member_group"
                  :checkAllGroup="listQuery.member_group"
                  :checkedValue="checkedShowValue"
                  :checkboxData="customerGroudList"
                  placeholder="请选择"
                  @member_group_even="member_group_even"
                ></dropCheckBox>
              </FormItem>
            </Col>
            <Col span="4" v-if="showOtherSearch">
              <FormItem label="用户类型" class="mb-10">
                <Select
                  v-model="listQuery.member_type_id"
                  placeholder="请选择用户类型"
                  style="90%"
                >
                  <Option
                    v-for="item in baseData.userType"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!--
            </Row>
            <Col v-if="showOtherSearch"> -->
            <Col span="4" v-if="showOtherSearch">
              <FormItem label="录入方式" class="mb-10">
                <Select
                  v-model="listQuery.insert_way_id"
                  style="90%"
                  placeholder="请选择录入方式"
                >
                  <Option
                    v-for="item in baseData.insert_way"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="4" v-if="showOtherSearch">
              <FormItem label="跟进状态" class="mb-10">
                <Select
                  v-model="listQuery.follow_status_id"
                  style="90%"
                  placeholder="请选择跟进状态"
                >
                  <Option
                    v-for="item in baseData.follow_status"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="10" v-if="showOtherSearch">
              <Col span="8">
                <FormItem label="跟进人" class="mb-10">
                  <Select
                    v-model="listQuery.follow_store_id"
                    @on-change="changeDepartment"
                    placeholder="请选择门店"
                  >
                    <Option
                      v-for="item in storeList"
                      :key="item.id"
                      :value="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem :label-width="0" class="mb-10">
                  <Select
                    v-model="listQuery.follow_department_id"
                    @on-change="changeFollowr"
                    placeholder="请选择部门"
                  >
                    <Option
                      v-for="item in followDepartmentList"
                      :key="item.id"
                      :value="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem :label-width="0" class="mb-10">
                  <Select
                    v-model="listQuery.follow_agent_id"
                    placeholder="请选择跟进人"
                  >
                    <Option
                      v-for="item in followrList"
                      :key="item.id"
                      :value="item.id"
                      >{{ item.user_name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Col>
            <Col span="4" v-if="showOtherSearch">
              <Checkbox
                v-model="listQuery.not_follow_agent"
                @on-change="not_follow_agent_change"
                style="margin-left: 15px; height: 30px; line-height: 30px"
                >未分配跟进人</Checkbox
              >
            </Col>

            <Col span="8" v-if="showOtherSearch">
              <FormItem label="预产期" class="mb-10">
                <DatePicker
                  type="date"
                  placeholder="请选择预产开始日期"
                  style="width: 45%"
                  :options="startBirthTime"
                  v-model="listQuery.child_birth_start"
                  @on-change="startTimeChange($event, 3)"
                ></DatePicker>
                <span> 至 </span>
                <DatePicker
                  type="date"
                  placeholder="请选择预产结束日期"
                  style="width: 45%"
                  :options="endBirthTime"
                  v-model="listQuery.child_birth_end"
                  @on-change="endTimeChange($event, 3)"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="8" v-if="showOtherSearch">
              <FormItem label="咨询日期" class="mb-10">
                <DatePicker
                  type="date"
                  placeholder="请选择咨询开始日期"
                  style="width: 45%"
                  :options="startConsultTime"
                  v-model="listQuery.consult_time_start"
                  @on-change="startTimeChange($event, 4)"
                ></DatePicker>
                <span> 至 </span>
                <DatePicker
                  type="date"
                  placeholder="请选择咨询结束日期"
                  style="width: 45%"
                  :options="endConsultTime"
                  v-model="listQuery.consult_time_end"
                  @on-change="endTimeChange($event, 4)"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="8" v-if="showOtherSearch">
              <FormItem label="分配时间" class="mb-10" :label-width="120">
                <DatePicker
                  type="date"
                  placeholder="请选择分配开始时间"
                  style="width: 45%"
                  :options="startDistributionTime"
                  v-model="listQuery.agent_time_start"
                  @on-change="startTimeChange($event, 2)"
                ></DatePicker>
                <span> 至 </span>
                <DatePicker
                  type="date"
                  placeholder="请选择分配结束时间"
                  style="width: 45%"
                  :options="endDistributionTime"
                  v-model="listQuery.agent_time_end"
                  @on-change="endTimeChange($event, 2)"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="渠道" class="mb-10" v-if="showOtherSearch">
                <Select
                  v-model="listQuery.enter_department_id"
                  @on-change="changeChannel"
                  placeholder="请选择部门"
                  style="width: 43%"
                >
                  <Option
                    v-for="item in departmentList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
                <Select
                  v-model="listQuery.enter_channel_id"
                  filterable
                  placeholder="请选择渠道"
                  style="width: 43%"
                >
                  <Option
                    v-for="item in channelList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>

            <!-- <Col span="3" v-if="showOtherSearch">
                    <Checkbox v-model="firstEnterStatus" @on-change="searchFirstTime" style="margin-left:15px;height:30px;line-height:30px">仅查询首次录入时间</Checkbox>
                </Col> -->
            <Col span="8" v-if="showOtherSearch">
              <FormItem label="下次回访时间" :label-width="90" class="mb-10">
                <DatePicker
                  type="date"
                  placeholder="请选择下次回访开始时间"
                  style="width: 45%"
                  :options="startVisitTime"
                  v-model="listQuery.visit_time_start"
                  @on-change="startTimeChange($event, 5)"
                ></DatePicker>
                <span> 至 </span>
                <DatePicker
                  type="date"
                  placeholder="请选择下次回访结束时间"
                  style="width: 45%"
                  :options="endVisitTime"
                  v-model="listQuery.visit_time_end"
                  @on-change="endTimeChange($event, 5)"
                ></DatePicker>
              </FormItem>
            </Col>

            <Col span="8" v-if="showOtherSearch">
              <FormItem
                label="最后一次回访时间"
                :label-width="120"
                class="mb-10"
              >
                <DatePicker
                  type="date"
                  placeholder="请选择最后一次回访时间开始时间"
                  style="width: 45%"
                  :options="startLastVisitTime"
                  v-model="listQuery.last_visit_time_start"
                  @on-change="startTimeChange($event, 6)"
                ></DatePicker>
                <span> 至 </span>
                <DatePicker
                  type="date"
                  placeholder="请选择最后一次回访时间结束时间"
                  style="width: 45%"
                  :options="endLastVisitTime"
                  v-model="listQuery.last_visit_time_end"
                  @on-change="endTimeChange($event, 6)"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="4" v-if="showOtherSearch">
              <FormItem label="产后客户类型" :label-width="85">
                <Select
                  v-model="listQuery.chankang_type"
                  placeholder="请选择产后客户类型"
                >
                  <Option
                    v-for="item in baseData.chankang_types"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="3" v-if="showOtherSearch">
              <FormItem label="跟进结果" class="mb-10">
                <Select v-model="listQuery.come_status_id" placeholder="请选择">
                 <Option
                      v-for="item in baseData.come_status"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                </Select>
              </FormItem>
            </Col>
            <Col
              span="8"
              class="opertionBtn_search"
              style="margin-bottom: 10px"
            >
              <Checkbox
                v-model="firstEnterStatus"
                v-if="showOtherSearch"
                @on-change="searchFirstTime"
                style="margin-left: 15px; margin-bottom: 0px; min-width: 150px"
                >仅查询首次录入时间</Checkbox
              >
              <Button
                class="item"
                type="primary"
                icon="ios-search"
                @click="searchList"
                >查询</Button
              >
              <Button class="item" @click="emptyFilter">清空筛选</Button>
              <Button
                class="item"
                type="text"
                style="color: #2d8cf0"
                @click="handleShowOtherSearch"
                >{{ showOtherSearch ? "收起" : "更多筛选" }}</Button
              >

              <FormItem
                style="margin-bottom: 0; min-width: 100px"
                :label-width="0"
              >
                <autoTableItem
                  type="customerManagement"
                  :defaultTable="defaultTable"
                  :autoTableData="autoTableData"
                  placeholder="表格展示项"
                  @autoTableRef="autoTableRef"
                >
                </autoTableItem>
              </FormItem>
            </Col>
          </Row>
          <!-- <Row  v-if="showOtherSearch">
                <Checkbox v-model="firstEnterStatus" @on-change="searchFirstTime" style="margin-left:15px;margin-bottom:10px">仅查询首次录入时间</Checkbox>
            </Row> -->

          <!-- <Row class="opertionBtn" v-if="showOtherSearch">
                <Button  class="item" type="primary" icon="ios-search" @click="searchList">查询</Button>
                <Button  class="item"   @click="emptyFilter">清空筛选</Button>
                <Button  class="item" type="text" style="color:#2d8cf0" @click="handleShowOtherSearch">{{showOtherSearch?'收起':'更多筛选'}}</Button>
                <FormItem  style="margin-bottom:0" :label-width="0">
                    <autoTableItem
                        type="customerManagement"
                        :defaultTable="defaultTable"
                        :autoTableData="autoTableData"
                        placeholder="表格展示项"
                        @autoTableRef="autoTableRef">
                    </autoTableItem>
                </FormItem>
            </Row> -->
        </Form>
      </div>
    </div>

    <div class="table_wrap">
      <div class="table_tip">
        <Button size="small" type="primary" @click="addBatchWithPeople"
          >分配跟进人</Button
        >
        <Button size="small" type="error" @click="deleteBatchWithPeople"
          >删除跟进人</Button
        >
      </div>
      <div style="width: 100%">
        <!--  :width="tableWidth" -->
        <Table
          stripe
          border
          ref="table"
          @on-sort-change="dataSort"
          @on-selection-change="batchAddFollow"
          :loading="tabLoading"
          :height="tableHeight"
          :columns="tabColumns"
          :data="tabData"
          class="table_style"
        >
        </Table>
        <div style="margin-top: 20px; display: flex; justify-content: flex-end">
          <Page
            show-total
            show-elevator
            show-sizer
            :page-size-opts="pageSizeOpts"
            :page-size="50"
            :total="total"
            :current="listQuery.page"
            :transfer="true"
            @on-change="changePage"
            @on-page-size-change="changeLimit"
          />
        </div>
      </div>
    </div>

    <!-- 批量分配跟进人对话框 -->
    <Modal
      v-model="showBatchAddWithPeople"
      :closable="false"
      :styles="stylesModal"
      :scrollable="true"
      :mask-closable="false"
      class-name="vertical-center-modal"
    >
      <p slot="header" class="modal_title">
        <span>{{
          isModalTitle == 7
            ? "分配跟进人"
            : isModalTitle == 8
            ? "删除跟进人"
            : ""
        }}</span>
      </p>
      <p class="modal_text" style="color: #464c5b">
        已选中{{ addBatchWithPeopleForm.member_ids.length }}条数据
      </p>
      <!-- <div style="text-align: center;margin-bottom:10px">
                    <Tag color="green">已选中{{addBatchWithPeopleForm.member_ids.length}}条数据</Tag>
                </div> -->
      <Form
        ref="addBatchWithPeopleForm"
        :model="addBatchWithPeopleForm"
        :rules="addBatchWithPeopleFormRule"
        :label-width="80"
        style="width: 70%"
      >
        <FormItem label="门店" prop="store_id">
          <Select
            v-model="addBatchWithPeopleForm.store_id"
            placeholder="请选择门店"
            disabled
          >
            <Option v-for="item in storeList" :key="item.id" :value="item.id">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="部门" prop="department_id">
          <Select
            v-model="addBatchWithPeopleForm.department_id"
            placeholder="请选择部门"
            @on-change="changeAddBatchFollowr"
          >
            <Option
              v-for="item in departmentList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="跟进人" prop="follow_user">
          <Select
            v-model="addBatchWithPeopleForm.follow_user"
            placeholder="请选择跟进人"
          >
            <Option
              v-for="item in followrBatchAddList"
              :key="item.id"
              :value="item.id"
              >{{ item.user_name }}</Option
            >
          </Select>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button
          type="primary"
          size="large"
          :loading="followLoading"
          @click="handleSubmit('addBatchWithPeopleForm')"
        >
          <span v-if="!followLoading">确定</span>
          <span v-else>
            {{
              isModalTitle == 7
                ? " 分配跟进人中..."
                : isModalTitle == 8
                ? "删除跟进人中..."
                : ""
            }}
          </span>
        </Button>
        <Button
          size="large"
          :loading="followLoading"
          @click="handleReset('addBatchWithPeopleForm')"
        >
          <span v-if="!followLoading">取消</span>
          <span v-else>
            {{
              isModalTitle == 7
                ? " 分配跟进人中..."
                : isModalTitle == 8
                ? "删除跟进人中..."
                : ""
            }}
          </span>
        </Button>
      </div>
    </Modal>

    <!-- 导出客户 -->
    <!-- <customerExcel
            type="curtomerManagement"
            :customerExcelShow="customerExcelShow"
            @customerExcelEven="customerExcelEven">
        </customerExcel> -->
    <customerExcel
      :excelTitle="excelTitle"
      :excelSteps="excelSteps"
      :downloadLink="downloadLink"
      :customerExcelShow="customerExcelShow"
      @customerExcelEven="customerExcelEven"
    >
    </customerExcel>
    <!-- 用户回访记录 -->
    <userAccessRecord
      type="customerManagement"
      :showAccessInfo="showAccessInfo"
      :accessInfoType="accessInfoType"
      :userId="userId"
      @Close="Close"
    >
    </userAccessRecord>

    <!-- 用户详情 -->
    <userDetails
      :showUserDetails="showUserDetails"
      :userId="userId"
      direct="curtomerManagement"
      @Close="isEditorOk"
    >
    </userDetails>
  </div>
</template>
<script>
import autoTableItem from "@/commonTmp/CRM/CRM_autoTableItem"; //表格自选项
import dropCheckBox from "@/commonTmp/dropCheckBox"; //多选下拉框
import customerExcel from "@/commonTmp/CRM/CRM_customerExcel"; //客户导出
import userAccessRecord from "@/commonTmp/CRM/CustomerManagementTmp/userAccessRecord"; //用户回访记录
import userDetails from "@/commonTmp/CRM/CustomerManagementTmp/userDetails"; //用户详情
export default {
  name: "customerManagementNew",
  components: {
    autoTableItem,
    dropCheckBox,
    customerExcel,
    userAccessRecord,
    userDetails,
  },
  data() {
    return {
      defaultStartEntryTime: util.getPreDate(90),
      defaultEndEntryTime: util.getPreDate(0),
      excelTitle: "",
      excelSteps: 1,
      downloadLink: "",
      userId: "",
      defaultTable: [
        "name",
        "phone",
        "member_status",
        "chankang_type_text",
        "follow_store_list",
        "my_store_group_list",
        "sex_text",
        "follow_list",
        "allot_time",
        "follow_status",
        "channel_info_list",
        "agent_name_list",
        "enter_time",
        "come_status",
      ],
      autoTableData: [
        {
          name: "姓名",
          id: "name",
          disabled: true,
        },
        {
          name: "手机号",
          id: "phone",
          disabled: true,
        },
        {
          name: "当前状态",
          id: "member_status",
          disabled: true,
        },
        {
          name: "跟进结果",
          id: "come_status",
        },
        {
          name: "产后客户类型",
          id: "chankang_type_text",
          disabled: false,
        },
        {
          name: "跟进门店",
          id: "follow_store_list",
          disabled: true,
        },
        {
          name: "本门店分组",
          id: "my_store_group_list",
          disabled: true,
        },
        {
          name: "用户类型",
          id: "member_type",
        },
        {
          name: "预产期",
          id: "child_birth",
        },
        {
          name: "咨询日期",
          id: "consult_time",
        },
        {
          name: "身份证",
          id: "id_card",
        },
        {
          name: "性别",
          id: "sex_text",
        },
        {
          name: "所在区域",
          id: "region",
        },
        {
          name: "详细地址",
          id: "address",
        },
        {
          name: "备注",
          id: "remark",
        },
        {
          name: "本门店跟进人",
          id: "follow_list",
        },
        {
          name: "本店跟进分配时间",
          id: "allot_time",
        },
        {
          name: "跟进状态",
          id: "follow_status",
        },
        {
          name: "最后一次回访时间",
          id: "last_visit_time",
        },
        {
          name: "最后一次回访内容",
          id: "visit_content",
        },
        {
          name: "下次回访时间",
          id: "next_visit_time",
        },
        {
          name: "渠道",
          id: "channel_info_list",
        },
        {
          name: "渠道说明",
          id: "channel_explain",
        },
        {
          name: "录入方式",
          id: "insert_way",
        },
        {
          name: "录入人员",
          id: "agent_name_list",
        },
        {
          name: "录入时间",
          id: "enter_time",
        },
      ],
      baseData: baseData,
      // downloadLoading:false,
      // downloadLoading_return:false,
      customerExcelShow: false,
      storeList: [],
      customerGroudList: [],
      departmentList: [],
      channelList: [],
      channelAddList: [],
      followrList: [],
      followrAddList: [],
      followrBatchAddList: [],
      followDepartmentList: [],

      checkedShowValue: "",
      // tableWidth:1000,
      tableHeight: 500,
      tabLoading: false,
      tabData: [],
      tabColumns: [],
      showOtherSearch: false,

      showBatchAddWithPeople: false,
      followLoading: false,
      addBatchWithPeopleForm: {
        member_ids: [],
        store_id: "",
        department_id: "",
        follow_user: "",
      },
      addBatchWithPeopleFormRule: {
        store_id: [
          {
            required: true,
            message: "请选择门店",
            trigger: "change",
            type: "number",
          },
        ],
        department_id: [
          {
            required: true,
            message: "请选择部门",
            trigger: "change",
            type: "number",
          },
        ],
        follow_user: [
          {
            required: true,
            message: "请选择跟进人",
            trigger: "change",
            type: "number",
          },
        ],
      },
      //导出Excel
      listQueryExcel: {},
      // 列表查询参数
      listQuery: {
        page: 1,
        limit: 50,
        // list_type:2,//客户管理
        first_enter_id: "", //仅查询首次录入时间
        store_id: [],
        keywords: "",
        enter_agent: "",
        enter_department_id: "",
        enter_channel_id: "",
        member_group: [],
        member_type_id: "",
        enter_time_start: "",
        enter_time_end: "",
        agent_time_start: "",
        agent_time_end: "",
        follow_store_id: "",
        follow_department_id: "",
        follow_agent_id: "",
        store_follow_status_id: "",
        insert_way_id: "",
        chankang_type: "",
        child_birth_start: "",
        child_birth_end: "",
        consult_time_start: "",
        consult_time_end: "",
        visit_time_start: "",
        visit_time_end: "",
        last_visit_time_start: "",
        last_visit_time_end: "",
        sort: {},
        not_follow_agent: false,
        come_status_id: "",
      },
      firstEnterStatus: false,
      total: 0,
      pageSizeOpts: [50, 60, 70, 80, 90, 100],

      columnsAll: [
        {
          type: "selection",
          width: 60,
          align: "center",
          // fixed: 'left'
        },
        {
          title: "ID",
          key: "id",
          align: "center",
          // width:100,
          // fixed: 'left'
        },
        {
          title: "姓名",
          key: "name",
          align: "center",
          // width:100,
          // fixed: 'left'
        },
        {
          title: "性别",
          key: "sex_text",
          align: "center",
          // width:70
        },
        {
          title: "手机号",
          align: "center",
          key: "phone",
          width: 140,
          render: (h, params) => {
            const row = params.row;
            const text = row.phone;
            return h("div", [
              h("span", { style: { textAlign: "center" } }, text),
              h("Button", {
                props: {
                  type: "text",
                  icon: "ios-paper-outline",
                },
                style: {},
                on: {
                  click: () => {
                    this.copy(text);
                  },
                },
              }),
            ]);
          },
        },
        {
          title: "当前状态",
          key: "member_status",
          align: "center",
          // width:180,
        },
        {
          title: "跟进结果",
          align: "center",
          key: "come_status",
          // width:180,
        },
        {
          title: "产后客户类型",
          key: "chankang_type_text",
          align: "center",
          // width:180,
        },
        
        {
          title: "跟进门店",
          align: "center",
          key: "follow_store_list",
          // width:180,
        },
        
        {
          title: "本门店分组",
          align: "center",
          key: "my_store_group_list",
          // width:180,
        },
        {
          title: "本门店跟进人",
          align: "center",
          key: "follow_list",
          // width:180,
        },
        {
          title: "跟进状态",
          align: "center",
          key: "follow_status",
          sortable: "custom",
          // width:180,
          render: (h, params) => {
            let follow_status = params.row.follow_status;
            var arr = [];
            for (var i = 0; i < follow_status.length; i++) {
              var color = "";
              var objStyle = {};
              switch (follow_status[i]) {
                case "未回访":
                  objStyle = {
                    props: { color: "#7093DB" },
                    style: { height: "auto", textAlign: "center" },
                  };
                  break;
                case "当天需回访":
                  objStyle = {
                    props: { color: "#FF7F00" },
                    style: { height: "auto", textAlign: "center" },
                  };
                  break;
                case "逾期未回访":
                  objStyle = {
                    props: { color: "#FF2400" },
                    style: { height: "auto", textAlign: "center" },
                  };
                  break;
                default:
                  objStyle = { style: { height: "auto", textAlign: "center" } };
              }
              if (follow_status.length == 1) {
                arr.push(h("Tag", objStyle, follow_status[i]));
              } else {
                arr.push(h("Tag", objStyle, i + 1 + "." + follow_status[i]));
              }
            }
            return h("div", arr);
          },
        },
        {
          title: "本店跟进分配时间",
          align: "center",
          key: "allot_time",
          sortable: "custom",
          // width:180,
        },
        {
          title: "渠道",
          align: "center",
          key: "channel_info_list",
          // width:180,
        },
        {
          title: "录入人员",
          align: "center",
          key: "agent_name_list",
          // width:180,
        },
        {
          title: "录入时间",
          align: "center",
          key: "enter_time",
          sortable: "custom",
          // width:180,
        },
        {
          title: "用户类型",
          align: "center",
          key: "member_type",
          // width:180,
        },
        {
          title: "预产期",
          align: "center",
          key: "child_birth",
          sortable: "custom",
          // width:180,
        },
        {
          title: "咨询日期",
          align: "center",
          key: "consult_time",
          sortable: "custom",
          // width:180,
        },
        {
          title: "身份证",
          align: "center",
          key: "id_card",
          // width:180,
        },

        {
          title: "所在区域",
          align: "center",
          key: "region",
          // width:180,
        },
        {
          title: "详细地址",
          align: "center",
          key: "address",
          // width:180,
        },
        {
          title: "备注",
          align: "center",
          key: "remark",
          // width:180,
        },
        {
          title: "最后一次回访时间",
          align: "center",
          key: "last_visit_time",
          sortable: "custom",
          // width:180,
        },
        {
          title: "最后一次回访内容",
          align: "center",
          key: "visit_content",
          // width:180,
        },
        {
          title: "下次回访时间",
          align: "center",
          key: "next_visit_time",
          sortable: "custom",
          // width:180,
        },
        {
          title: "渠道说明",
          align: "center",
          key: "channel_explain",
          // width:180,
        },
        {
          title: "录入方式",
          align: "center",
          key: "insert_way",
          // width:180,
        },
        {
          title: "操作",
          width: 170,
          align: "center",
          // fixed: 'right',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.userId = params.row.id.toString();
                      this.showUserDetails = true;
                    },
                  },
                },
                "客户详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.userId = params.row.id.toString();
                      this.showAccessInfo = true;
                    },
                  },
                },
                "回访记录"
              ),
            ]);
          },
        },
      ],
      // 限制选择日期
      startBirthTime: {},
      endBirthTime: {},
      startConsultTime: {},
      endConsultTime: {},
      startVisitTime: {},
      startLastVisitTime: {},
      endLastVisitTime: {},
      endVisitTime: {},
      startEntryTime: {},
      endEntryTime: {},
      startDistributionTime: {},
      endDistributionTime: {},
      // ************ 回访信息 ************
      showAccessInfo: false,
      accessInfoType: "store",
      isModalTitle: 1,
      stylesModal: {
        height: "500px",
      },
      // ************ 客户详情 ************
      showUserDetails: false,
    };
  },
  created() {
    if (window.agent_info)
      this.addBatchWithPeopleForm.store_id = window.agent_info.store_id;
    if (Lockr.get("customerManagement"))
      this.defaultTable = Lockr.get("customerManagement");
    this.listQuery.enter_time_start = this.dateFormat(
      Date.parse(this.defaultStartEntryTime)
    );
    this.listQuery.enter_time_end = this.dateFormat(
      Date.parse(this.defaultEndEntryTime)
    );
    this.getList();
    this.apiStoreAll();
    this.apiGetMemberGroupList();
    this.apiDepartmentAll();
  },
  mounted() {
    this.tableHeight =
      window.innerHeight - this.$refs.table.$el.offsetTop - 220;
    // this.tableWidth = window.innerWidth -200
  },
  methods: {
    //监听未分配跟进人
    not_follow_agent_change(status) {
      if (status) {
        this.listQuery.follow_store_id = "";
        this.listQuery.follow_department_id = "";
        this.listQuery.follow_agent_id = "";
        this.followDepartmentList = [];
        this.followrList = [];
      }
    },
    //导出客户
    excelCustomer() {
      this.excelTitle = "导出客户Excel";
      this.excelSteps = 1;
      this.customerExcelShow = true;
    },
    //导出回访
    exportReturnRecord() {
      this.excelTitle = "导出回访记录";
      this.excelSteps = 1;
      this.customerExcelShow = true;
    },
    Close() {
      this.showAccessInfo = false;
    },
    //监听表格自选
    autoTableRef(data) {
      Lockr.set("customerManagement", data);
      let getTableHead = [this.columnsAll[0], this.columnsAll[1]];
      for (let item of data) {
        switch (item) {
          case "name":
            getTableHead.push(this.columnsAll[2]);
            break;
          case "sex_text":
            getTableHead.push(this.columnsAll[3]);
            break;
          case "phone":
            getTableHead.push(this.columnsAll[4]);
            break;
          case "member_status":
            getTableHead.push(this.columnsAll[5]);
            break;
          case "come_status":
            getTableHead.push(this.columnsAll[6]);
            break;
          case "chankang_type_text":
            getTableHead.push(this.columnsAll[7]);
            break;
          case "follow_store_list":
            getTableHead.push(this.columnsAll[8]);
            break;
          case "my_store_group_list":
            getTableHead.push(this.columnsAll[9]);
            break;
          case "follow_list":
            getTableHead.push(this.columnsAll[10]);
            break;
          case "follow_status":
            getTableHead.push(this.columnsAll[11]);
            break;
          case "allot_time":
            getTableHead.push(this.columnsAll[12]);
            break;
          case "channel_info_list":
            getTableHead.push(this.columnsAll[13]);
            break;
          case "agent_name_list":
            getTableHead.push(this.columnsAll[14]);
            break;
          case "enter_time":
            getTableHead.push(this.columnsAll[15]);
            break;
          case "member_type":
            getTableHead.push(this.columnsAll[16]);
            break;
          case "child_birth":
            getTableHead.push(this.columnsAll[17]);
            break;
          case "consult_time":
            getTableHead.push(this.columnsAll[18]);
            break;
          case "id_card":
            getTableHead.push(this.columnsAll[19]);
            break;
          case "region":
            getTableHead.push(this.columnsAll[20]);
            break;
          case "address":
            getTableHead.push(this.columnsAll[21]);
            break;
          case "remark":
            getTableHead.push(this.columnsAll[22]);
            break;
          case "last_visit_time":
            getTableHead.push(this.columnsAll[23]);
            break;
          case "visit_content":
            getTableHead.push(this.columnsAll[24]);
            break;
          case "next_visit_time":
            getTableHead.push(this.columnsAll[25]);
            break;
          case "channel_explain":
            getTableHead.push(this.columnsAll[26]);
            break;
          case "insert_way":
            getTableHead.push(this.columnsAll[27]);
            break;
        }
      }
      getTableHead.push(this.columnsAll[28]);
      this.tabColumns = getTableHead;
    },
    // 表格数据排序
    dataSort(column) {
      if (column.order != "normal") {
        switch (column.column.title) {
          case "录入时间":
            this.listQuery.sort.sort = column.order;
            this.listQuery.sort.field = "channel_infos_created_at";
            break;
          case "本店跟进分配时间":
            this.listQuery.sort.sort = column.order;
            this.listQuery.sort.field = "follows_created_at";
            break;
          case "跟进状态":
            this.listQuery.sort.sort = column.order;
            this.listQuery.sort.field = "follows_follow_status";
            break;
          case "预产期":
            this.listQuery.sort.sort = column.order;
            this.listQuery.sort.field = "maternal_infos_child_birth";
            break;
          case "最后一次回访时间":
            this.listQuery.sort.sort = column.order;
            this.listQuery.sort.field = "visits_created_at";
            break;
          case "下次回访时间":
            this.listQuery.sort.sort = column.order;
            this.listQuery.sort.field = "visits_visit_time";
            break;
          case "咨询日期":
            this.listQuery.sort.sort = column.order;
            this.listQuery.sort.field = "members_consult_time";
            break;
        }
        this.getList();
      }
    },
    // 门店
    apiStoreAll() {
      serve
        .fetchGet(api.storeMemberStoreAll, {})
        .then((data) => {
          this.storeList = data.data;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 客户分组
    apiGetMemberGroupList() {
      serve
        .fetchGet(api.storeMemberGroupAll, {})
        .then((data) => {
          this.customerGroudList = data.member_groups;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //部门
    apiDepartmentAll(store_id) {
      let params = {};
      if (store_id) {
        params.store_id = store_id;
      }
      serve
        .fetchGet(api.memberDepartmentAll, params)
        .then((data) => {
          console.log(data);
          if (store_id) {
            this.followDepartmentList = data.data;
          } else {
            this.departmentList = data.data;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //渠道
    apiChannelAll(id, type = 1) {
      serve
        .fetchGet(api.memberStoreMemberAll, { department_id: id })
        .then((data) => {
          if (type == 1) {
            this.channelList = data.data;
          } else {
            this.channelAddList = data.data;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //获取跟进人
    apiFollowr(id, store_id, type = 1) {
      serve
        .fetchGet(api.memberStoreMemberAgentAll, {
          department_id: id,
          store_id: store_id,
        })
        .then((data) => {
          switch (type) {
            case 1:
              this.followrList = data.data;
              break;
            case 2:
              this.followrAddList = data.data;
              break;
            case 3:
              this.followrBatchAddList = data.data;
              break;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 批量分配跟进人
    apiAddBatchFollow() {
      let params = {
        member_ids: this.addBatchWithPeopleForm.member_ids,
        department_id: this.addBatchWithPeopleForm.department_id,
        follow_user: this.addBatchWithPeopleForm.follow_user,
      };
      this.followLoading = true;
      serve
        .fetchPost(api.memberBatchAllotFollowUser, params)
        .then((res) => {
          this.$Message.success("添加成功");
          this.addBatchWithPeopleForm.member_ids = [];
          this.getList();
          this.followLoading = false;
          this.showBatchAddWithPeople = false;
        })
        .catch((error) => {
          this.followLoading = false;
          this.$Message.error(error.response.data.message);
        });
    },
    // 批量删除跟进人
    apiDeleteBatchFollow() {
      let params = {
        member_ids: this.addBatchWithPeopleForm.member_ids,
        department_id: this.addBatchWithPeopleForm.department_id,
        follow_user: this.addBatchWithPeopleForm.follow_user,
      };
      this.followLoading = true;
      serve
        .fetchPut(api.memberBatchDelFollowUser, params)
        .then((res) => {
          this.$Message.success("删除成功");
          this.addBatchWithPeopleForm.member_ids = [];
          this.getList();
          this.followLoading = false;
          this.showBatchAddWithPeople = false;
        })
        .catch((error) => {
          this.followLoading = false;
          this.$Message.error(error.response.data.message);
        });
    },
    // 获取列表
    getList() {
      this.tabLoading = true;
      // console.log('请求参数',this.listQuery)
      let getList = this.listQuery;
      if (!getList.not_follow_agent) {
        delete getList.not_follow_agent;
      }
      this.listQueryExcel = JSON.parse(JSON.stringify(getList));
      serve
        .fetchGet(api.getStoreMemberListNew, this.listQuery)
        .then((res) => {
          var data = res.data;
          console.log("客户管理列表", data);
          if (data.length) {
            for (var i = 0; i < data.length; i++) {
              var item = data[i];
              //跟进门店
              item.follow_store_list = item.follow_store_list.length
                ? item.follow_store_list
                    .map((val, i, arr) => {
                      if (arr.length != 1) {
                        return i + 1 + "." + val;
                      } else {
                        return val;
                      }
                    })
                    .join("\n")
                : "";
              item.come_status = item.come_status.length
                ? item.come_status
                    .map((val, i, arr) => {
                      if (arr.length != 1) {
                        return i + 1 + "." + val;
                      } else {
                        return val;
                      }
                    })
                    .join("\n")
                : "";
              //本门店分组
              item.my_store_group_list = item.my_store_group_list.length
                ? item.my_store_group_list
                    .map((val, i, arr) => {
                      if (arr.length != 1) {
                        return i + 1 + "." + val;
                      } else {
                        return val;
                      }
                    })
                    .join("\n")
                : "";
              //本门店跟进人
              item.follow_list = item.follow_list.length
                ? item.follow_list
                    .map((val, i, arr) => {
                      if (arr.length != 1) {
                        return i + 1 + "." + val;
                      } else {
                        return val;
                      }
                    })
                    .join("\n")
                : "";
              //跟进状态
              // item.follow_status = item.follow_status.length?item.follow_status.join('\n'):''
              //跟进人分配时间
              item.allot_time = item.allot_time.length
                ? item.allot_time.join("\n")
                : "";
              //渠道
              item.channel_info_list = item.channel_info_list.length
                ? item.channel_info_list
                    .map((val, i, arr) => {
                      if (arr.length != 1) {
                        return i + 1 + "." + val;
                      } else {
                        return val;
                      }
                    })
                    .join("\n")
                : "";
              //录入人员
              item.agent_name_list = item.agent_name_list.length
                ? item.agent_name_list
                    .map((val, i, arr) => {
                      if (arr.length != 1) {
                        return i + 1 + "." + val;
                      } else {
                        return val;
                      }
                    })
                    .join("\n")
                : "";
              //录入时间
              item.enter_time = item.enter_time.length
                ? item.enter_time.join("\n")
                : "";
              //渠道说明
              item.channel_explain = item.channel_explain.length
                ? item.channel_explain.join("\n")
                : "";
              //录入方式
              item.insert_way = item.insert_way.length
                ? item.insert_way.join("\n")
                : "";
              // 预产期
              item.child_birth = item.child_birth.length
                ? item.child_birth.join("\n")
                : "";

              // var visitCon=item.visit_content
              // // 下次回访时间
              // if(visitCon!=null&&visitCon.visit_time!=undefined&&visitCon.visit_time!=null){
              //     item.next_visit_time = visitCon.visit_time
              // }else{
              //     item.next_visit_time = ''
              // }
              // 最后一次回访内容
              // var visitConStr=''
              // if(visitCon!=null&&visitCon.type!=null&&visitCon.type!=undefined){
              //     if(visitCon.type==1){
              //         if(visitCon.member_group!=null&&visitCon.member_group.name!=null){
              //             visitConStr+=visitCon.member_group.name+' '
              //         }
              //         if(visitCon.come_name!=null&&visitCon.come_name.name!=null){
              //             visitConStr+=visitCon.come_name.name+' '
              //         }
              //         if(visitCon.return_name!=null&&visitCon.return_name.name!=null){
              //             visitConStr+=visitCon.return_name.name+': '
              //         }
              //         if(visitCon.content!=null){
              //             visitConStr+=visitCon.content+' '
              //         }
              //         if(visitCon.store_name!=null&&visitCon.store_name.name!=null){
              //             visitConStr+=visitCon.store_name.name+' '
              //         }
              //         if(visitCon.department_name!=null&&visitCon.department_name.name!=null){
              //             visitConStr+=visitCon.department_name.name+' '
              //         }
              //         if(visitCon.agent_name!=null&&visitCon.agent_name.user_name!=null){
              //             visitConStr+=visitCon.agent_name.user_name
              //         }
              //     }else if(visitCon.type==2){
              //         visitConStr+='系统记录：'
              //         if(visitCon.operate_log!=null){
              //             visitConStr+=visitCon.operate_log+' '
              //         }
              //         if(visitCon.content!=null){
              //             visitConStr+=visitCon.content+' '
              //         }
              //         if(visitCon.store_name!=null&&visitCon.store_name.name!=null){
              //             visitConStr+=visitCon.store_name.name+' '
              //         }
              //         if(visitCon.department_name!=null&&visitCon.department_name.name!=null){
              //             visitConStr+=visitCon.department_name.name+' '
              //         }
              //         if(visitCon.agent_name!=null&&visitCon.agent_name.user_name!=null){
              //             visitConStr+=visitCon.agent_name.user_name
              //         }
              //     }
              //     item.next_visit_content=visitConStr
              // }else{
              //     item.next_visit_content=''
              // }
            }
          }
          console.log("data", data);
          this.tabData = data;
          this.total = res.meta.pagination.total;
          this.tabLoading = false;
        })
        .catch((error) => {
          this.tabLoading = false;
          this.$Message.error(error.response.data.message);
        });
    },
    //获取客户导出列表
    getUserListExcel(params) {
      // this.downloadLoading = true
      this.$Message.loading({
        content: "正在获取导出链接",
        duration: 100,
      });
      serve
        .fetchGet(api.storeMemberExport, params)
        .then((res) => {
          console.log("客户管理导出列表", res);
          this.$Message.destroy();
          this.downloadLink = res.url;
          this.excelSteps = 2;
          this.customerExcelShow = true;
          // require.ensure([], () => {
          //     const { export_json_to_excel } = require('@/vendor/Export2Excel')
          //     var filterArr=[]
          //     var labelHeader = []
          //     for(let item of this.tabColumns){
          //         if(item.title !=undefined && item.title != '操作' && item.title != 'ID'){
          //             labelHeader.push(item.title)
          //             filterArr.push(item.key)
          //         }
          //     }
          //     const tHeader = labelHeader
          //     const filterVal = filterArr
          //     const list = res.data
          //     const data = this.formatJson(filterVal, list)
          //     export_json_to_excel(tHeader, data, '客户管理')
          //     this.downloadLoading = false
          // })
        })
        .catch((error) => {
          this.$Message.destroy();
          this.$Message.error(error.response.data.message);
        });
    },
    //获取客户回访导出列表
    getUserAccessListExcel(params) {
      this.$Message.loading({
        content: "正在获取导出链接",
        duration: 100,
      });
      serve
        .fetchGet(api.storeMemberVisitExport, params)
        .then((res) => {
          console.log("客户管理回访记录", res);
          this.$Message.destroy();
          this.downloadLink = res.url;
          this.excelSteps = 2;
          this.customerExcelShow = true;
          // require.ensure([], () => {
          //     const { export_json_to_excel } = require('@/vendor/Export2Excel')
          //     var labelHeader = ['姓名','回访记录']
          //     var filterArr=['name','vistis']
          //     const tHeader = labelHeader
          //     const filterVal = filterArr
          //     const list = res.data
          //     const data = this.formatJson(filterVal, list)
          //     export_json_to_excel(tHeader, data, '客户管理回访记录')
          //     this.downloadLoading_return = false
          // })
        })
        .catch((error) => {
          this.$Message.destroy();
          // this.downloadLoading_return = false
          this.$Message.error(error.response.data.message);
        });
    },
    // formatJson(filterVal, jsonData) {
    //     return jsonData.map(v => filterVal.map(j => v[j]))
    // },
    changeChannel(id) {
      this.listQuery.enter_channel_id = "";
      this.apiChannelAll(id);
    },
    changeDepartment(id) {
      this.listQuery.not_follow_agent = false;
      this.listQuery.follow_department_id = "";
      this.listQuery.follow_agent_id = "";
      this.apiDepartmentAll(id);
    },
    changeFollowr(id) {
      this.listQuery.not_follow_agent = false;
      this.listQuery.follow_agent_id = "";
      this.apiFollowr(id, this.listQuery.follow_store_id);
    },
    changePage(val) {
      this.listQuery.page = val;
      this.getList();
    },
    changeLimit(val) {
      this.listQuery.page = 1;
      this.listQuery.limit = val;
      this.getList();
    },
    changeAddBatchFollowr(id) {
      this.addBatchWithPeopleForm.follow_user = "";
      this.apiFollowr(id, this.addBatchWithPeopleForm.store_id, 3);
    },
    searchFirstTime(status) {
      if (status) {
        this.listQuery.first_enter_id = "1";
        this.firstEnterStatus = true;
      } else {
        this.listQuery.first_enter_id = "";
        this.firstEnterStatus = false;
      }
    },

    isEditorOk() {
      this.showUserDetails = false;
      this.getList();
    },
    //监听客户分组
    member_group_even(data, val) {
      this.listQuery.member_group = data;
      this.checkedShowValue = val;
    },
    //添加客户
    addMember() {
      this.apiAddMemberAuth();
    },
    //新增客户权限
    apiAddMemberAuth(create_type) {
      serve
        .fetchGet(api.memberAddMemberBtn, {})
        .then((data) => {
          console.log("新增客户权限", data);
          if (data[0]) {
            this.$router.push({
              path: "/addMember?type=member",
            });
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    batchAddFollow(data) {
      var arr = [];
      if (data.length) {
        for (var i = 0; i < data.length; i++) {
          arr.push(data[i].id);
        }
      }
      this.addBatchWithPeopleForm.member_ids = arr;
    },
    handleShowOtherSearch() {
      if (this.showOtherSearch) {
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 40;
      } else {
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 430;
      }
      this.showOtherSearch = !this.showOtherSearch;
    },
    // 清空筛选
    emptyFilter() {
      this.defaultEndEntryTime = "";
      this.defaultStartEntryTime = "";
      this.listQuery.page = 1;
      this.listQuery.store_id = [];
      this.listQuery.keywords = "";
      this.listQuery.enter_agent = "";
      this.listQuery.enter_department_id = "";
      this.listQuery.enter_channel_id = "";
      this.listQuery.member_group = [];
      this.checkedShowValue = "";
      this.listQuery.member_type_id = "";
      this.listQuery.enter_time_start = "";
      this.listQuery.enter_time_end = "";
      this.listQuery.agent_time_start = "";
      this.listQuery.agent_time_end = "";
      this.listQuery.follow_store_id = "";
      this.listQuery.follow_department_id = "";
      this.listQuery.follow_agent_id = "";
      this.listQuery.store_follow_status_id = "";
      this.listQuery.insert_way_id = "";

      this.listQuery.child_birth_start = "";
      this.listQuery.child_birth_end = "";
      this.listQuery.consult_time_start = "";
      this.listQuery.consult_time_end = "";
      this.listQuery.visit_time_start = "";
      this.listQuery.visit_time_end = "";
      this.listQuery.last_visit_time_start = "";
      this.listQuery.last_visit_time_end = "";

      this.listQuery.first_enter_id = "";
      this.firstEnterStatus = false;
      this.listQuery.sort = {};
      this.listQuery.not_follow_agent = false;
      this.listQuery.come_status_id = "";
      this.listQuery.chankang_type = "";
      this.getList();
    },
    // 查询
    searchList() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 复制
    copy(copyInfo) {
      let oInput = document.createElement("input");
      oInput.value = copyInfo;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$Message.success("复制成功");
    },
    //批量添加跟进人
    addBatchWithPeople() {
      if (this.addBatchWithPeopleForm.member_ids.length != 0) {
        this.isModalTitle = 7;
        this.addBatchWithPeopleForm.store_id = window.agent_info.store_id;
        this.addBatchWithPeopleForm.department_id = "";
        this.addBatchWithPeopleForm.follow_user = "";
        this.$refs.addBatchWithPeopleForm.resetFields();
        this.showBatchAddWithPeople = true;
      } else {
        this.$Message.warning("请勾选客户");
      }
    },
    // 批量删除跟进人
    deleteBatchWithPeople() {
      if (this.addBatchWithPeopleForm.member_ids.length != 0) {
        this.isModalTitle = 8;
        this.addBatchWithPeopleForm.store_id = window.agent_info.store_id;
        this.addBatchWithPeopleForm.department_id = "";
        this.addBatchWithPeopleForm.follow_user = "";
        this.$refs.addBatchWithPeopleForm.resetFields();
        this.showBatchAddWithPeople = true;
      } else {
        this.$Message.warning("请勾选客户");
      }
    },
    // 确认
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          switch (name) {
            case "addBatchWithPeopleForm":
              switch (this.isModalTitle) {
                case 7:
                  this.apiAddBatchFollow();
                  break;
                case 8:
                  this.apiDeleteBatchFollow();
                  break;
              }
              break;
          }
        } else {
          this.$Message.error("请完善表单");
        }
      });
    },
    // 取消
    handleReset(name) {
      this.$refs[name].resetFields();
      switch (name) {
        case "addBatchWithPeopleForm":
          this.showBatchAddWithPeople = false;
          break;
      }
    },
    //限制结束时间
    startTimeChange(e, index) {
      switch (index) {
        case 1:
          this.listQuery.enter_time_start = e;
          var startTime = this.listQuery.enter_time_start
            ? new Date(this.listQuery.enter_time_start).valueOf() -
              1 * 24 * 60 * 60 * 1000
            : "";
          this.endEntryTime = {
            disabledDate: (date) => {
              return date && date.valueOf() < startTime;
            },
          };
          break;
        case 2:
          this.listQuery.agent_time_start = e;
          var startTime = this.listQuery.agent_time_start
            ? new Date(this.listQuery.agent_time_start).valueOf() -
              1 * 24 * 60 * 60 * 1000
            : "";
          this.endDistributionTime = {
            disabledDate: (date) => {
              return date && date.valueOf() < startTime;
            },
          };
          break;
        case 3:
          this.listQuery.child_birth_start = e;
          var startTime = this.listQuery.child_birth_start
            ? new Date(this.listQuery.child_birth_start).valueOf() -
              1 * 24 * 60 * 60 * 1000
            : "";
          this.endBirthTime = {
            disabledDate: (date) => {
              return date && date.valueOf() < startTime;
            },
          };
          break;

        case 4:
          this.listQuery.consult_time_start = e;
          var startTime = this.listQuery.consult_time_start
            ? new Date(this.listQuery.consult_time_start).valueOf() -
              1 * 24 * 60 * 60 * 1000
            : "";
          this.endConsultTime = {
            disabledDate: (date) => {
              return date && date.valueOf() < startTime;
            },
          };
          break;
        case 5:
          this.listQuery.visit_time_start = e;
          var startTime = this.listQuery.visit_time_start
            ? new Date(this.listQuery.visit_time_start).valueOf() -
              1 * 24 * 60 * 60 * 1000
            : "";
          this.endVisitTime = {
            disabledDate: (date) => {
              return date && date.valueOf() < startTime;
            },
          };
          break;
        case 6:
          this.listQuery.last_visit_time_start = e;
          var startTime = this.listQuery.last_visit_time_start
            ? new Date(this.listQuery.last_visit_time_start).valueOf() -
              1 * 24 * 60 * 60 * 1000
            : "";
          this.endLastVisitTime = {
            disabledDate: (date) => {
              return date && date.valueOf() < startTime;
            },
          };
          break;
      }
    },
    //限制开始时间
    endTimeChange(e, index) {
      switch (index) {
        case 1:
          this.listQuery.enter_time_end = e;
          var endTime = this.listQuery.enter_time_end
            ? new Date(this.listQuery.enter_time_end).valueOf()
            : "";
          this.startEntryTime = {
            disabledDate: (date) => {
              return date && date.valueOf() > endTime;
            },
          };
          break;
        case 2:
          this.listQuery.agent_time_end = e;
          var endTime = this.listQuery.agent_time_end
            ? new Date(this.listQuery.agent_time_end).valueOf()
            : "";
          this.startDistributionTime = {
            disabledDate: (date) => {
              return date && date.valueOf() > endTime;
            },
          };
          break;
        case 3:
          this.listQuery.child_birth_end = e;
          var endTime = this.listQuery.child_birth_end
            ? new Date(this.listQuery.child_birth_end).valueOf()
            : "";
          this.startBirthTime = {
            disabledDate: (date) => {
              return date && date.valueOf() > endTime;
            },
          };
          break;

        case 4:
          this.listQuery.consult_time_end = e;
          var endTime = this.listQuery.consult_time_end
            ? new Date(this.listQuery.consult_time_end).valueOf()
            : "";
          this.startConsultTime = {
            disabledDate: (date) => {
              return date && date.valueOf() > endTime;
            },
          };
          break;
        case 5:
          this.listQuery.visit_time_end = e;
          var endTime = this.listQuery.visit_time_end
            ? new Date(this.listQuery.visit_time_end).valueOf()
            : "";
          this.startVisitTime = {
            disabledDate: (date) => {
              return date && date.valueOf() > endTime;
            },
          };
          break;
        case 6:
          this.listQuery.last_visit_time_end = e;
          var endTime = this.listQuery.last_visit_time_end
            ? new Date(this.listQuery.last_visit_time_end).valueOf()
            : "";
          this.startLastVisitTime = {
            disabledDate: (date) => {
              return date && date.valueOf() > endTime;
            },
          };
          break;
      }
    },
    //时间格式化
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day;
    },
    //监听导出客户
    // customerExcelEven(status,is_export,value){
    //     this.customerExcelShow = status
    //     if(is_export){
    //         if(value == 1){
    //             this.getUserListExcel(this.listQueryExcel)
    //         }
    //         if(value == 2){
    //             this.getUserListExcel({})
    //         }
    //     }
    // },
    customerExcelEven(val, is_export, params, title) {
      this.customerExcelShow = val;
      if (is_export) {
        if (title == "导出客户Excel") {
          if (params.value == 1) {
            let listQueryExcel = this.listQueryExcel;
            listQueryExcel.email = params.mail;
            listQueryExcel.channel_info_sort = params.channel_info_sort;
            this.getUserListExcel(listQueryExcel);
            return;
          }
          if (params.value == 2) {
            this.getUserListExcel({
              email: params.mail,
              channel_info_sort: params.channel_info_sort,
            });
          }
          return;
        }
        if (title == "导出回访记录") {
          if (params.value == 1) {
            let listQueryExcel = this.listQueryExcel;
            listQueryExcel.email = params.mail;
            this.getUserAccessListExcel(listQueryExcel);
            return;
          }
          if (params.value == 2) {
            this.getUserAccessListExcel({ email: params.mail });
          }
        }
      }
    },
  },
};
</script>
<style scope>
.mr-t-10 {
  margin-top: 10px;
}
.content {
}
.search_bar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}
.search_bar_item {
  /* text-align: center; */
  margin: 4px;
}
.other_search_bar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.table_wrap {
  margin: 12px 0px 12px 0px;
}
.ivu-btn-icon-only {
  margin-left: 4px;
  padding: 0px !important;
  font-size: 18px !important;
}
.ivu-table-cell {
  white-space: pre-line !important;
}
.ivu-drawer-header-inner {
  font-size: 20px !important;
}
.table_tip {
  height: 24px;
  margin: 0 0 10px 0px;
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  z-index: 10;
}
.user_info_wrap {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  height: 40px;
  color: #464c5b;
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  background: #f8f8f9;
  margin: 10px 0;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal {
  top: 0;
}
.modal_title {
  text-align: center;
}
.modal_text {
  color: red;
  text-align: center;
  margin-bottom: 16px;
}
.user_info_text_wrap {
  height: 46px;
  padding-top: 10px;
  padding-left: 32px;
  /* line-height: 56px; */

  /* padding: 10px; */
}
.TimelineItemTime {
  font-size: 14px;
  font-weight: bold;
}
.TimelineItemContent {
  padding-left: 5px;
}
.topBtn {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8eaec;
  padding-top: 10px;
  padding-right: 5px;
  background: rgba(249, 249, 249);
}
.topBtn .item {
  margin-left: 5px;
}
.header_search {
  border: 1px solid #e8eaec;
}
.opertionBtn_search {
  display: flex !important;
  display: -webkit-flex !important;
  align-items: center;
}
.opertionBtn_search .item {
  margin-right: 5px;
}
.table_style .ivu-table-cell {
  padding-left: 2px;
  padding-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Crm/UserManagement/customerManagementNew.vue